import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

const NAV_ITEMS = [
    { icon: '🏠', label: 'Base Camp', to: '/dashboard' },
    { icon: '⚔️', label: 'Quests', to: '/courses' },
    { icon: '🏆', label: 'Rankings', to: '/leaderboard' },
    { icon: '🎮', label: 'Player Card', to: '/profile' },
];

export default function BottomBar() {
    return (
        <nav className="md:hidden fixed bottom-0 inset-x-0 z-[100] h-16 bg-game-surface/95 backdrop-blur-xl border-t border-white/10">
            <div className="grid grid-cols-5 h-full">
                {NAV_ITEMS.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) => cn(
                            'flex flex-col items-center justify-center gap-1 transition-all',
                            isActive ? 'text-game-primary-l' : 'text-game-dim hover:text-game-muted'
                        )}
                    >
                        <span className="text-xl leading-none">{item.icon}</span>
                        <span className="text-[9px] font-heading font-black uppercase tracking-widest leading-none">
                            {item.label}
                        </span>
                    </NavLink>
                ))}

                {/* Settings — icon only to fit 5 items */}
                <NavLink
                    to="/settings"
                    className={({ isActive }) => cn(
                        'flex flex-col items-center justify-center transition-all',
                        isActive ? 'text-game-primary-l' : 'text-game-dim hover:text-game-muted'
                    )}
                >
                    <span className="text-xl leading-none">⚙️</span>
                </NavLink>
            </div>
        </nav>
    );
}
